export const getAllEnquiryList = (state: any) => state.enquiry.enquiryList;
export const getEnquiryDetail = (state: any) => state.enquiry.enquiryDetail;
export const getSaleCallLog = (state: any) => state.enquiry.callLog;
export const getSaleStatusList = (state: any) => state.enquiry.saleStatusList;
export const getTenantCreated = (state: any) => state.enquiry.tenantCreated;
